import { stopSubmit } from 'redux-form';
import moment from 'moment';

export const emailReg = /^.+@.+\..{2,24}$/;

export const REQUIRED = 'required';
export const INVALID_EMAIL = 'invalid_email_address';
export const INVALID_DATE = 'invalid_date';
export const MUST_BE_THE_SAME = 'must_be_the_same';
export const MUST_BE_THE_DIFFERENCE = 'must_be_the_difference';
export const MAX_ALLOWED_180_DAYS = 'max_180_days';
export const MUST_BE_POSITIVE = 'must_be_positive';

export const rules = {
  required(v) {
    return v ? undefined : REQUIRED;
  },
  email(v) {
    return /.+/i.test(v) ? undefined : INVALID_EMAIL;
  },
  emailExtended(v) {
    return emailReg.test(v) ? undefined : INVALID_EMAIL;
  },
  same(v, ...rest) {
    return rest.reduce((A, V) => {
      if (typeof A === 'undefined') {
        if (V !== v) return MUST_BE_THE_SAME;
        return undefined;
      }
      return A;
    }, undefined);
  },
  strMinLength(v, len, message) {
    return (v || '').toString().length < len ? message : undefined;
  },
  strMaxLength(v, len, message) {
    return (v || '').toString().length > len ? message : undefined;
  },
  numMaxValue(v, max, message) {
    return v > max ? message : undefined;
  },
  numMinValue(v, min, message) {
    return v < min ? message : undefined;
  },
  date(v) {
    const d = moment(v);
    return d.isValid() ? undefined : INVALID_DATE;
  },
  isMomentValue(v) {
    return moment.isMoment(v) ? undefined : INVALID_DATE;
  },
  difference(v, o) {
    return v !== o ? undefined : MUST_BE_THE_DIFFERENCE;
  },
};

export function addError(fieldName, err) {
  return (errors) => {
    if (errors[fieldName]) return errors;
    if (typeof err !== 'undefined') {
      return { ...errors, [fieldName]: err };
    }
    return errors;
  };
}

export function makeErrorAction(errors) {
  if (typeof errors === 'string') return { _error: errors };
  if (Array.isArray(errors)) {
    if (typeof errors[0] === 'string') {
      return { _error: errors[0] };
    }
    throw new Error('Incorrect format error message');
  }
  const res = (r) => (Array.isArray(r) ? r[0] : r);
  return Object.keys(errors).reduce((A, field) => ({ ...A, [field]: res(errors[field]) }), {});
}

export function asyncErrorAction(formName, errors) {
  return stopSubmit(formName, makeErrorAction(errors));
}
